import React from 'react';
import { Layout } from 'components/organisms';
import { SubwebUpdateForm, Authenticator } from 'containers';
import { useParams } from 'react-router-dom';


const ThePage = () => {
  const { subweb } = useParams();

  return (
    <Authenticator requires="admin" subweb={subweb} redirect="/">
      <Layout subtitle="definições" hasSubwebHeader>
        <SubwebUpdateForm subweb={subweb} />
      </Layout>
    </Authenticator>
  );
};

export default ThePage;
